// Code generated by apps/cctool-go/scripts/gen-info-edit-policy. DO NOT EDIT.
//
// The server's Information edit policy, written from the Go source so that the
// Angular console's copy cannot drift from it. Regenerate with
// `just regen-openapi` from the repository root: the guards workflow fails a
// pull request whose copy is stale.
//
// INFO_FIELDS: the Information fields of PUT /invoices/{id}/information, in
//   the request schema's order (invoicestate.AllInfoFields).
// INFO_EDIT_POLICY: invoicestate.InfoEditPolicyFor for every invoice state, in
//   the FSM's declaration order: whether the state allows an Information edit
//   at all, and the fields whose value it locks. The Information widget offers
//   the fields this leaves editable.

import { InvoiceStateId } from '../api/models/invoice-state-id';

export const INFO_FIELDS = [
  "amount",
  "iban",
  "date",
  "due_date",
  "express_payment",
  "new_invoice_number",
  "new_reference_number",
  "number",
  "original_reference_number",
  "lead_source_id",
  "responsible_seller_id",
] as const;

export type InfoField = (typeof INFO_FIELDS)[number];

export interface InfoEditPolicy {
  readonly allowed: boolean;
  readonly locked_fields: readonly InfoField[];
}

export const INFO_EDIT_POLICY: Readonly<Record<InvoiceStateId, InfoEditPolicy>> = {
  "PreCheck": {
    allowed: true,
    locked_fields: [],
  },
  "WaitingForPrepaymentRegister": {
    allowed: true,
    locked_fields: [],
  },
  "NoPrepaymentRegister": {
    allowed: false,
    locked_fields: [],
  },
  "WaitingForRepresentativeMandate": {
    allowed: true,
    locked_fields: [],
  },
  "NoMandate": {
    allowed: false,
    locked_fields: [],
  },
  "WaitingInvoiceInformation": {
    allowed: true,
    locked_fields: [],
  },
  "WaitingForCreditDecision": {
    allowed: true,
    locked_fields: [],
  },
  "WaitingForDisputeCheck": {
    allowed: true,
    locked_fields: [],
  },
  "Disputed": {
    allowed: false,
    locked_fields: [],
  },
  "CreditRatingNotOk": {
    allowed: false,
    locked_fields: [],
  },
  "Rejected": {
    allowed: false,
    locked_fields: [],
  },
  "WaitingForOfferToBeSent": {
    allowed: true,
    locked_fields: [],
  },
  "WaitingForOfferApproval": {
    allowed: true,
    locked_fields: [],
  },
  "OfferRejected": {
    allowed: false,
    locked_fields: [],
  },
  "WaitingForFinancing": {
    allowed: true,
    locked_fields: [],
  },
  "Closed": {
    allowed: false,
    locked_fields: [],
  },
  "WaitingForInvoiceToEndCustomer": {
    allowed: true,
    locked_fields: [
      "amount",
      "due_date",
      "express_payment",
      "new_invoice_number",
      "new_reference_number",
      "number",
    ],
  },
  "MonitoringEndCustomerPayments": {
    allowed: true,
    locked_fields: [
      "amount",
      "date",
      "due_date",
      "express_payment",
      "new_invoice_number",
      "new_reference_number",
      "number",
    ],
  },
  "WaitingFinalPayment": {
    allowed: true,
    locked_fields: [
      "amount",
      "date",
      "due_date",
      "express_payment",
      "new_invoice_number",
      "new_reference_number",
      "number",
    ],
  },
  "WaitingForReport": {
    allowed: true,
    locked_fields: [
      "amount",
      "iban",
      "date",
      "due_date",
      "express_payment",
      "new_invoice_number",
      "new_reference_number",
      "number",
      "original_reference_number",
    ],
  },
  "Completed": {
    allowed: true,
    locked_fields: [
      "amount",
      "iban",
      "date",
      "due_date",
      "express_payment",
      "new_invoice_number",
      "new_reference_number",
      "number",
      "original_reference_number",
    ],
  },
  "WaitingForDisputeMailToBeSent": {
    allowed: true,
    locked_fields: [],
  },
};
